import {
  IContactRequestData,
  IContactRequestPostData
} from '../../entities'
import {
  ICustomerService
} from './index'
import {
  AxiosInstance,
  AxiosResponse
} from 'axios'
import {
  defaultConfig
} from '../config'


export class CustomerService implements ICustomerService {
  constructor(private readonly axios: AxiosInstance) {}

  async addContactRequest(data: IContactRequestPostData, language?: string): Promise<AxiosResponse<IContactRequestData>> {
    return this.axios.post('/contact_request/add/', data, defaultConfig(language));
  }

}
